module.exports = __webpack_public_path__ + "static/media/soup.f864052f.svg";